import { Editor, Extensions } from '@tiptap/core';
import React from 'react';

import { HeadingOptions, Level } from '@/ui/Editor/extensions';

import { Select } from '../../Select';
import { useTranslation } from 'react-i18next';

interface HeadingsMenuItemProps {
	editor: Editor | null;
}

type THeading = {
	label: string;
	value: 0 | Level;
	className?: string;
};

const HeadingsMenuItem = (props: HeadingsMenuItemProps) => {
	const { editor } = props;
	const { t } = useTranslation()

	const extensions: Extensions = editor?.extensionManager?.extensions ?? [];

	const headings = React.useMemo(() => {
		if (editor) {
			const options = extensions.find((extension) => extension.name === 'headings')?.options as HeadingOptions;
			const headings = options?.levels ?? [];

			return headings.reduce(
				(result, { level }) => {
					result.push({
						value: level,
						label: `${t('form.head') } ${level}`,
					});

					return result;
				},
				[{ value: 0, label: t('form.sText') }]
			);
		}

		return [];
	}, [editor]);

	if (!editor) {
		return null;
	}

	return (
		<div className="flex gap-2">
			<Select
				value={
					headings.find((heading) => editor.getAttributes('headings').level === heading.value) || headings[0]
				}
				isSearchable={false}
				defaultValue={headings[0]}
				options={headings}
				onChange={({ value }: THeading) => {
					if (!value) {
						editor.chain().focus().setParagraph().run();

						return;
					}

					editor.chain().focus().toggleHeading({ level: value }).run();
				}}
			/>
		</div>
	);
};

export { HeadingsMenuItem };
